/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const es_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar`)
};

const de_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

const nl_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetten`)
};

const fr_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser`)
};

const it_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina`)
};

const pt_br2_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir`)
};

const pt_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repor`)
};

const ja_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リセット`)
};

const zh_ruler_reset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_reset = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_reset(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_reset", locale)
	if (locale === "en") return en_ruler_reset(inputs)
	if (locale === "es") return es_ruler_reset(inputs)
	if (locale === "de") return de_ruler_reset(inputs)
	if (locale === "nl") return nl_ruler_reset(inputs)
	if (locale === "fr") return fr_ruler_reset(inputs)
	if (locale === "it") return it_ruler_reset(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_reset(inputs)
	if (locale === "pt") return pt_ruler_reset(inputs)
	if (locale === "ja") return ja_ruler_reset(inputs)
	return zh_ruler_reset(inputs)
};